import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Fractal Tree — branching organic tree structure.
 * bent3D + linear3D for trunk/branches, power3D for
 * branch tapering, and sinusoidal3D for leaf-like tips.
 */
export const example42 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Fractal Tree',
    description:
      'branching organic tree structure. bent3D + linear3D for trunk/branches, power3D for branch tapering, and sinusoidal3D for leaf-like tips.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.1,
    skipIters: 20,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.1,
    contrast: 4.2,
    gamma: 3.4,
    depthColorPower: 0.0,
    lightDirection: [-0.4, 0.6, -0.7],
    lightPower: 0.1,
    highlightPower: 0.85,
    densityEstimationQuality: 0.65,
    estimatorCurve: 0.4,
    paletteMode: 0,
    palettePhase: 0.05,
    paletteSpeed: 0.4,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 1.0,
      phi: 1.4,
      radius: 2.6,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_tree_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.75,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.75,
        g: 0,
        h: 0.25,
        i: 0,
        j: 0,
        k: 0.75,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.1, y: 0.2 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_tree_a_v0')]: { type: 'bent3D', weight: 0.8 },
        [vid('3d_tree_a_v1')]: { type: 'linear3D', weight: 0.4 },
      },
    },
    [tid('3d_tree_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.6,
        b: 0.2,
        c: 0,
        d: 0.1,
        e: -0.2,
        f: 0.6,
        g: 0,
        h: 0.15,
        i: 0,
        j: 0,
        k: 0.6,
        l: 0.1,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.1, y: 0.4 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_tree_b_v0')]: { type: 'power3D', weight: 0.6 },
        [vid('3d_tree_b_v1')]: { type: 'bent3D', weight: 0.3 },
      },
    },
    [tid('3d_tree_c')]: {
      probability: 0.15,
      preAffine: {
        a: 0.6,
        b: -0.2,
        c: 0,
        d: -0.1,
        e: 0.2,
        f: 0.6,
        g: 0,
        h: 0.15,
        i: 0,
        j: 0,
        k: 0.6,
        l: 0.1,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.3, y: 0.5 },
      colorSpeed: 0.4,
      variations: {
        [vid('3d_tree_c_v0')]: { type: 'power3D', weight: 0.6 },
        [vid('3d_tree_c_v1')]: { type: 'bent3D', weight: 0.3 },
      },
    },
    [tid('3d_tree_d')]: {
      probability: 0.15,
      preAffine: {
        a: 0.45,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.45,
        g: 0,
        h: 0.3,
        i: 0,
        j: 0,
        k: 0.45,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.5, y: -0.1 },
      colorSpeed: 0.3,
      variations: {
        [vid('3d_tree_d_v0')]: { type: 'sinusoidal3D', weight: 0.5 },
        [vid('3d_tree_d_v1')]: { type: 'julia3D', weight: 0.3 },
      },
    },
  },
})
